export default __webpack_public_path__ + "assets/logo_vinterbyn-a1d185d7.svg";